/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import restClient from '../../app/helpers/restClient';

const fetchOrderDetailsAPI = (jwt, payload, headers) => {
    const wcEnv = {
        rootUri: '/',
    };
    const resourcePath = 'retention/selfservice/order/status';
    return restClient.postFacade(wcEnv, resourcePath, jwt, payload, null, headers, false).then((response) => response);
};

export default fetchOrderDetailsAPI;
